import gpio from "gpio";
import I2C from "i2c";

const I2C_DEVICE = "/dev/i2c-1";
const CHIP_ADDRESS = 0x10;

if (!global.__queue)
  global.__queue = [];

/* TODO: use bottleneck library for scheduling purposes */
/* TODO: store sumML on device side                     */

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

class Parallax {
  static constructor() {
    setInterval(Parallax.scheduler, 100);
  }  
  static scheduler() {
    if (!global.__queue.length)
      return;

    if (!(global.__queue[global.__queue.length-1]).running) {
      global.__queue[global.__queue.length-1].running = true;
      global.__queue[global.__queue.length-1].run();
    }
  }
  constructor(chip_address, pumpid) {
    this.__chip_address = chip_address;
    this.__pumpid = pumpid;

    this.id = "";
    this.status = "uninitialized";
    this.rpm = 0;
    this.mlh = 0;
    this.sumML = 0;
    
    jfermi.addEventListener("fermentationstart", this.#fermentationstart_handler.bind(this));    
  }
  /* when the fermentation stops we reset the summa value */
  #fermentationstart_handler(fermentation) {  
    if (!fermentation.isContinuation) {
      this.clearSum();
    }
  }    
  async initialize() {
    try {
      this.__bus = new I2C();
      await this.__bus.open(I2C_DEVICE, CHIP_ADDRESS);

      this.id = await this.command("GetInfo");      
      await this.command(`SetRPM${this.__pumpid} 0`);
      this.rpm = 0;
      this.mlh = 0;
      this.calibrationStatus = await this.command(`GetCal${this.__pumpid}`);      
      this.sumML = parseFloat(localStorage.getItem(`__Pump${this.__pumpid}SumML`)) || 0;
      this.status = "OK";
      setInterval(this.__ontimeout.bind(this), 1000);
    } catch(e) {
      this.id = "-";
      this.status = "Failed: "+e.message;
      throw e;
    }
  }
  calibrate(rpm, mlh) {
    return( new Promise(function(rpm, mlh, resolve, reject) {
      this.command(`SetCal${this.__pumpid},${rpm},${mlh}`).then(function(result) {
        return this.command(`GetCal${this.__pumpid}`);
      }.bind(this)).then(function(result) {
        this.calibrationStatus = result;
        resolve(true);
      }.bind(this)).catch(function(result) {
        reject(result);
      }.bind(this));
    }.bind(this, rpm, mlh)) );
  }
  clearSum() {
    this.sumML = 0;
    return true;
  }
  setRPM(value) {
    return( new Promise(function(value, resolve, reject) {
      this.command(`SetRPM${this.__pumpid} ${value}`).then(function(result) {
        this.rpm = value;
        resolve(true);
      }.bind(this)).catch(function(result) {
        reject(result);
      }.bind(this));
    }.bind(this, value)) );
  }
  setMLH(value) {
    return( new Promise(function(value, resolve, reject) {
      this.command(`SetMLH${this.__pumpid} ${value}`).then(function(result) {
        this.mlh = value;
        resolve(true);
      }.bind(this)).catch(function(result) {
        reject(result);
      }.bind(this));
    }.bind(this, value)) );
  }
  command(cmd) {
    function Deferred(that) {
      var self = this;
      this.run = function(cmd) {
	//console.log(cmd);
        //this.__chip_address = 0x10;
        that.__bus.write( new TextEncoder().encode(cmd+"\0") ).then(function(result) {
          return sleep(100);
        }.bind(this)).then(function(result) {
          return that.__bus.read(100);
        }.bind(this)).then(function(result) {
          var uint8array = new Uint8Array(result);
          uint8array = uint8array.filter(v => v != 0);
          if (uint8array[0]==0) this.reject("no pending request");
          var string = String.fromCharCode.apply(null, uint8array);
	  //console.log(string);
          this.resolve(string);
        }.bind(this)).catch(function(e) {
		  console.error(`parallax.js: writeBlockData failed: ${e}`);
          this.reject(e);
        }.bind(this));    
      }.bind(this, cmd);

      this.promise = new Promise(function(resolve, reject) {
        self.resolve = resolve;
        self.reject = reject;
      });
    }

    var deferred = new Deferred(this);

    global.__queue.unshift(deferred);

    deferred.promise.then(function(result) {
      global.__queue.pop();
    });
    deferred.promise.catch(function(result) {
      global.__queue.pop();
    });

    return(deferred.promise);
  }

  __ontimeout() {
    var rpm = parseFloat(this.calibrationStatus.split(",")[1]);
    var mlh = parseFloat(this.calibrationStatus.split(",")[2]);
    this.sumML += (this.mlh/(60*60));
    
    /* we save the sum just in case if the fermentor restarts for some reason. For example.: power outage for a minute */
    //localStorage.setItem(`__Pump${this.__pumpid}SumML`, this.sumML);
  }
}

Parallax.constructor();

export default Parallax;